import React, { type FC } from 'react'
import { SvgIcon, type SvgIconProps } from '@mui/material'

export const LogsIcon: FC<SvgIconProps> = (props) => (
    <SvgIcon data-testid="LogsIcon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <g id="icon/logs">
            <path
                fill="none"
                id="Vector"
                d="M13 12H21M13 18H21M13 6H21M3 12H4M3 18H4M3 6H4M8 12H9M8 18H9M8 6H9"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            >
            </path>
        </g>
    </SvgIcon>
)
